// extracted by mini-css-extract-plugin
export default {"checkBoxWrap":"styles_checkBoxWrap__YcsQp","box":"styles_box__2F1PJ","type":"styles_type__7Fjey"};